<template>
<section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
            <el-form-item>
                <el-input v-model="filters.cardSegBt" placeholder="卡号段开始"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="filters.cardSegEt" placeholder="卡号段截止"></el-input>
            </el-form-item>

            <el-form-item>
                <el-input v-model="filters.likeCardKey" placeholder="卡号"></el-input>
            </el-form-item>

            <el-form-item v-if='dealstateShow'>
                <el-select v-model="filters.limitstate" placeholder="处理状态" clearable>
                    <el-option v-for="item in options_limitstate" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" v-on:click="getCards">查询</el-button>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="exportExcel">导出EXCEL</el-button>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="handleAll" v-if='dealstateShow'>一键处理</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="cards" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
        <el-table-column prop="msisdn" label="卡号" sortable>
        </el-table-column>
        <el-table-column prop="packagename" label="套餐名称" sortable>
        </el-table-column>
        <el-table-column prop="limitstoptime" label="停机时间" sortable>
        </el-table-column>
        <el-table-column prop="currmonthflowlimit" label="当月流量阀值(M)" sortable>
        </el-table-column>
        <el-table-column prop="gprsused" label="已用流量" sortable>
        </el-table-column>
        <el-table-column prop="limitstate" label="处理状态" width="120" v-if='dealstateShow' sortable>
            <template scope="scope">
                <el-tag :type="scope.row.limitstate === '1' ? 'danger' : 'success' " close-transition>{{scope.row.limitstate == 1 ? '待处理' : '已处理' }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="230" fixed="right" v-if="userlevel==0 ">
            <template scope="scope">
                <el-button size="small" @click="handleMore(scope.$index, scope.row)">详细</el-button>
                <el-button v-if="scope.row.limitstate === '1'" size="small" @click="dealCard(scope.$index, scope.row)">处理</el-button>
                <el-button size="small" @click="showQrcode(scope.row)">二维码</el-button>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="160" fixed="right" v-else>
            <template scope="scope">
                <el-button size="small" @click="handleMore(scope.$index, scope.row)">详细</el-button>
                <el-button size="small" @click="showQrcode(scope.row)">二维码</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!--工具条(分页)-->
    <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
    </el-col>

    <!--卡号信息详情界面-->
    <cardinfo ref="cardinfo"></cardinfo>
    <Cardbuyflow ref="Cardbuyflow"></Cardbuyflow>

</section>
</template>

<script>
import util from '../../common/js/util'
import constant from '../../common/js/constant'
//import NProgress from 'nprogress'
import CardBuyflow from '../../components/card_buyflow.vue';
import Cardinfo from '../../components/card_info.vue';
import {
    getStopDataCardListPage,
    outgprsStop,
    outgprsStopAll,
    getOutgprsCardsTotal
} from '../../api/api';

export default {
    components: {
        cardinfo: Cardinfo,
        Cardbuyflow: CardBuyflow
    },
    data() {
        return {
            filters: {
                //卡号段开始
                cardSegBt: '',
                //卡号段截止		                
                cardSegEt: '',
                //模糊查询卡关键字
                likeCardKey: '',
                //处理状态
                limitstate: ''
            },
            cards: [],
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            listLoading: false,
            sels: [], //列表选中列
            options_limitstate: [
                {
                    value: '1',
                    label: '待处理'
                }, 
                {
                    value: '2',
                    label: '已处理'
                }
            ],
            dealstateShow: false,
            userlevel: null,

        }
    },
    methods: {
        selsChange: function (sels) {
            this.sels = sels;
        },
        exportExcel() {
            let para = "";
            para += "&cardSegBt=" + ((!this.filters.cardSegBt || this.filters.cardSegBt == '') ? '' : this.filters.cardSegBt);
            para += "&cardSegEt=" + ((!this.filters.cardSegEt || this.filters.cardSegEt == '') ? '' : this.filters.cardSegEt);
            para += "&likeCardKey=" + ((!this.filters.likeCardKey || this.filters.likeCardKey == '') ? '' : this.filters.likeCardKey);
            para += "&limitstate=" + ((!this.filters.limitstate || this.filters.limitstate == '') ? '' : this.filters.limitstate);
            location.href = "/api/cards/exportStopDataXls?" + para;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCards();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getCards();
        },
        //获取卡号列表
        getCards() {
            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };
            this.filters.likeCardKey = this.filters.likeCardKey.trim();
            para = Object.assign(para, this.filters);

            this.listLoading = true;
            getStopDataCardListPage(para).then((res) => {
                this.total = res.data.total;
                this.cards = res.data.list;
                /*if(this.cards != null && this.cards.length > 0){
                    for(var i=0;i<this.cards.length;i++){
                        this.cards[i].currmonthflowlimit = this.cards[i].currmonthflowlimit + 'M';
                    }
                }*/
                this.listLoading = false;
            });
        },
        //显示二维码界面
        showQrcode: function (row) {
            this.$refs.Cardbuyflow.showCardQrcode(row.msisdn);
            // let price = parseFloat(row.rechargePrice);
            // if (price <= 0) {
            //     this.$message({
            //         message: "请先设置该物联网卡的充值价格！",
            //         type: 'error'
            //     });
            //     return;
            // } else {
                
            // }

        },
        //显示卡号详细界面
        handleMore: function (index, row) {
            this.$refs.cardinfo.showCardDetail(row.msisdn);
        },
        // 处理操作
        dealCard: function (index, row) {
            this.$confirm('确认对此卡进行数据关停操作！', '提示', {
                type: 'warning'
            }).then(() => {
                this.listLoading = true;
                
                let para = {
                    'msisdn': row.msisdn
                };
                outgprsStop(para).then((res) => {
                    this.listLoading = false;
                    if(res.code == 0){
                        this.$message({
                            message: '停机成功',
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                    }
                    this.getCards();
                });
            });
        },
        handleAll: function(){
            getOutgprsCardsTotal().then((res) => {
                var todoOutGprsTotal = res.data.todoOutGprsTotal;
                if(todoOutGprsTotal > 0){
                    this.$confirm('确认对所有待处理的卡进行数据关停操作！', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.listLoading = true;
                        
                        outgprsStopAll().then((res) => {
                            this.listLoading = false;
                            if(res.code == 0){
                                this.$message({
                                    message: res.msg,
                                    type: 'success'
                                });
                            }else{
                                this.$message({
                                    message: res.msg,
                                    type: 'error'
                                });
                            }
                            this.getCards();
                        });
                    });
                }else{
                    this.$message({
                        message: '未找到待处理的卡',
                        type: 'error'
                    });
                }
            });
        },

    },
    mounted() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            this.userlevel = user.userlevel;
            if (user.userlevel == 0) {
                this.dealstateShow = true;
                this.filters.limitstate = '1';
            } else {
                this.dealstateShow = false;
                this.filters.limitstate = '';
            }
        }

        this.getCards();
    }
}
</script>



// WEBPACK FOOTER //
// datastopcard.vue?5240bfac